module.exports = __webpack_public_path__ + "img/award_02.9f4203b.png";